import { render, staticRenderFns } from "./campaignsNumbers.vue?vue&type=template&id=22b0f2ed&scoped=true&"
import script from "./campaignsNumbers.vue?vue&type=script&lang=js&"
export * from "./campaignsNumbers.vue?vue&type=script&lang=js&"
import style0 from "./campaignsNumbers.vue?vue&type=style&index=0&id=22b0f2ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0f2ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
